import { createApi } from "@reduxjs/toolkit/query/react";
import { nexusApiUrl } from "../../../env";
import { makeBaseQueryWithUnauthentication } from "../../redux/api/baseQuery";
import { TAGS } from "./types";

export const emptyNexusApi = createApi({
	reducerPath: "nexusApi",
	baseQuery: makeBaseQueryWithUnauthentication({
		baseUrl: nexusApiUrl,
		// WHY guarded: RTK runs this after an endpoint's own headers, so a plain set overwrites an endpoint asking for a newer version.
		prepareHeaders: (headers) => {
			if (!headers.has("x-api-version")) {
				headers.set("x-api-version", "2.0.0");
			}
		},
	}),
	tagTypes: TAGS,
	endpoints: () => ({}),
});
